import { useState } from 'react';
import { useSelector } from 'react-redux';

import {
  Bar,
  BarChart,
  Brush,
  CartesianGrid,
  LabelList,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

import { MaskValor } from '../../../../../component';
import { IChartProps, StickyTooltip } from '../../../../../component/charts';
import ChartCard from '../../../../../component/charts/chartCard';

import {
  labelFormatterNumber,
  labelFormatterPercentile,
} from '../../../../../shared/formatters/formatters';

import { TransactionedOverExistingRealtiesChartData } from './types';

export const TransactionedOverExistingRealties: React.FC = () => {
  const { requestStatusT, chartsDataTransactions } = useSelector(
    (state: any) => state.realtyTransactionsState
  );

  return (
    <ChartCard
      data={
        chartsDataTransactions?.value['transactioned_over_existing_realties']
      }
      cy={'TransactionedOverExistingRealties'}
      id={'transactionedOverExistingRealties'}
      Chart={TransactionedOverExistingRealtiesChart}
      requestStatus={requestStatusT['transactionedOverExistingRealties']}
      hasAnnualDataOnly
    />
  );
};

const TransactionedOverExistingRealtiesChart: React.FC<
  IChartProps<TransactionedOverExistingRealtiesChartData[]>
> = ({ data, cy, id }) => {
  data = data?.map((el: any) => ({
    ...el,
    transactioned_percent: Number(el.transactioned_percent),
  }));
  const [hasClicked, setHasClicked] = useState<boolean>(false);
  const [recordTooltip, setRecordTooltip] = useState<JSX.Element | null>(null);
  const [stopChange, setStopChange] = useState<boolean>(false);
  const formatterFunctions = [labelFormatterNumber, labelFormatterPercentile];
  return (
    <ResponsiveContainer data-cy={`transactionedOverExistingRealties${cy}`}>
      <BarChart
        id={id}
        data={data}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 5,
        }}
        onClick={() => setHasClicked(!hasClicked)}
      >
        <Tooltip
          wrapperStyle={{ visibility: 'visible' }}
          content={
            <StickyTooltip
              hasClicked={hasClicked}
              recordTooltip={recordTooltip}
              setRecordTooltip={setRecordTooltip}
              stopChange={stopChange}
              setStopChange={setStopChange}
              formatterFunctions={formatterFunctions}
            />
          }
        />
        <CartesianGrid strokeDasharray="3 3 3" />

        <XAxis dataKey="id" />
        <YAxis yAxisId="left" orientation="left" stroke="#8884d8" />
        <YAxis
          dataKey=""
          yAxisId="right"
          orientation="right"
          stroke="#492273"
          tickFormatter={(tick) => `${tick}%`}
        />
        <Legend iconType="circle" />
        {/* <Bar
          yAxisId="left"
          isAnimationActive={false}
          name="Existentes"
          dataKey="value"
          fill="#8884d8"
        >
          <LabelList
            dataKey="value"
            position="top"
            formatter={(v: any) => MaskValor(v)}
          />
        </Bar> */}
        <Bar
          yAxisId="right"
          isAnimationActive={false}
          name="T.S.E"
          dataKey="transactioned_percent"
          fill="#492273"
          label={{ position: 'top', formatter: labelFormatterPercentile }}
        ></Bar>
        <Brush dataKey="id" height={30} stroke="#8884d8" />
      </BarChart>
    </ResponsiveContainer>
  );
};
